'use client';
import { jsx } from 'react/jsx-runtime';
import { useMenu } from '@react-aria/menu';
import { useEffect } from 'react';
import { MenuItemInternal } from './menu-item-internal.js';
import { MenuSectionInternal } from './menu-section-internal.js';
import { useSwanMenuListContext } from './menu-list.context.js';
import { useCollectionContext } from '../../contexts/internal/collection/collection.context.js';
import { renderWithRef } from '../core/render-with-ref.js';
import { useSwanPopover } from '../popover/popover.context.js';
import { assignRefs } from '../../../core/utilities/ref.utils.js';

function _define_property(e, t, r) {
    return t in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: true,
        configurable: true,
        writable: true
    }) : e[t] = r, e;
}
function _object_spread(e) {
    for(var t = 1; t < arguments.length; t++){
        var r = null != arguments[t] ? arguments[t] : {}, o = Object.keys(r);
        "function" == typeof Object.getOwnPropertySymbols && (o = o.concat(Object.getOwnPropertySymbols(r).filter(function(e) {
            return Object.getOwnPropertyDescriptor(r, e).enumerable;
        }))), o.forEach(function(t) {
            _define_property(e, t, r[t]);
        });
    }
    return e;
}
function ownKeys(e, t) {
    var r = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r.push.apply(r, o);
    }
    return r;
}
function _object_spread_props(e, t) {
    return t = null != t ? t : {}, Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
        Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    }), e;
}
const MenuList = renderWithRef('MenuList', null, (n, m)=>{
    let { children: l, className: u, 'aria-label': b } = n, { setChildItems: f } = useCollectionContext(), { overlayState: y } = useSwanPopover(), { menuProps: O, menuState: j, menuRef: _ } = useSwanMenuListContext();
    useEffect(()=>{
        f(()=>l);
    }, [
        f,
        l
    ]);
    let { menuProps: w } = useMenu(_object_spread_props(_object_spread({}, O), {
        'aria-label': b
    }), j, _), d = assignRefs(m, _), P = new Set([
        'swan-menu-list',
        'swan-listbox-list'
    ]);
    return u && P.add(u), jsx("ul", _object_spread_props(_object_spread({}, n, w), {
        ref: d,
        className: [
            ...P
        ].join(' '),
        children: y.isOpen ? [
            ...j.collection
        ].map((t)=>'section' === t.type ? jsx(MenuSectionInternal, {
                section: t,
                state: j
            }, t.key) : jsx(MenuItemInternal, {
                item: t,
                state: j
            }, t.key)) : null
    }));
});

export { MenuList };
